import { render, staticRenderFns } from "./Detail_AD.vue?vue&type=template&id=31812e84&scoped=true&"
import script from "./Detail_AD.vue?vue&type=script&lang=js&"
export * from "./Detail_AD.vue?vue&type=script&lang=js&"
import style0 from "./Detail_AD.vue?vue&type=style&index=0&id=31812e84&lang=less&scoped=true&"
import style1 from "./Detail_AD.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31812e84",
  null
  
)

export default component.exports